import { render, staticRenderFns } from "./nameConfig.vue?vue&type=template&id=550ab904"
import script from "./nameConfig.vue?vue&type=script&lang=js"
export * from "./nameConfig.vue?vue&type=script&lang=js"
import style0 from "./nameConfig.vue?vue&type=style&index=0&id=550ab904&prod&lang=scss&scope=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports